var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCalndr = function SvgCalndr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#898989",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 1 0v2a.5.5 0 0 1-.5.5Zm6 0a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 1 0v2a.5.5 0 0 1-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13h-10C.673 13 0 12.327 0 11.5v-9C0 1.673.673 1 1.5 1h10c.827 0 1.5.673 1.5 1.5v9c0 .827-.673 1.5-1.5 1.5ZM1.5 2a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5H.5a.5.5 0 0 1 0-1h12a.5.5 0 1 1 0 1ZM4 6h1v1H4V6Zm2 0h1v1H6V6Zm2 0h1v1H8V6Zm2 0h1v1h-1V6ZM2 8h1v1H2V8Zm2 0h1v1H4V8Zm2 0h1v1H6V8Zm2 0h1v1H8V8Zm2 0h1v1h-1V8Zm-8 2h1v1H2v-1Zm2 0h1v1H4v-1Zm2 0h1v1H6v-1Z"
  }))));
};
export default SvgCalndr;